import DetailVM from './detail-vm';
var initFileView = function(){
  var viewstate = 'grid';
  var $fileContent = $( $('#file-view-nav').data('target') );

  $('#file-grid-view').on('click', function() {
    $fileContent.removeClass('list-view').addClass('grid-view');
    $('#file-grid-view').addClass('selected');
    $('#file-list-view').removeClass('selected');
    viewstate = 'grid';
  });

  $('#file-list-view').on('click', function() {
    $fileContent.removeClass('grid-view').addClass('list-view');
    $('#file-list-view').addClass('selected');
    $('#file-grid-view').removeClass('selected');
    viewstate = 'list';
  });
};

export default {
  init: function() {
    console.log('SessionView initialization function called');

    var el = document.getElementById('video-lectures');
    if (el) {
      ko.applyBindings( new DetailVM(), document.getElementById('video-lectures') );
    }

    initFileView();
  }
};

